<template>
    <div id="ai-chat">
        <transition name="fade">
        <div id="ai-chat-container" v-show="opened">
                <div id="ai-chatbox">
                    <div id="ai-chatbox-header">
                        {{ env != 'admin' ? __('ai_chatbox', 'chat_with_our_ai_assistant') : 'Chat with AI Assistant' }}
                        <i class="fa fa-times" @click="toggleOpen"></i>
                    </div>
                    <div id="ai-chatbox-messages">
                        <div v-if="env != 'admin' && settings.ai_chatbox_greeting_message">
                            <div class="message assistant">
                                <div class="role-label">{{ t.ai_chatbox.ai_assistant }}:</div>
                                <div v-html="settings.ai_chatbox_greeting_message"></div>
                            </div>
                        </div>
                        <div v-if="env == 'admin'" class="message assistant">
                            <div class="role-label">AI Assistant:</div>
                            <div v-html="greeting_message"></div>
                        </div>
                        <div v-for="(chatMessage, index) in chatMessages" :key="index" class="message"
                            :class="chatMessage.role">
                            <div class="role-label text-capitalize" v-if="env == 'admin'">{{ chatMessage.role }}:</div>
                            <div class="role-label" v-else>{{ chatMessage.role == 'assistant' ? t.ai_chatbox.ai_assistant : t.ai_chatbox.you }}:</div>
                            <div v-html="chatMessage.content"></div>
                        </div>
                    </div>
                    <div id="ai-chatbox-footer">
                        <input :placeholder="env != 'admin' ? __('ai_chatbox', 'type_your_message_here') : 'Type your message here'"
                        type="text" v-model="message"
                            @keyup.enter="sendMessage" :disabled="loading" style="resize:none" />
                        <div class="btn-send" @click="sendMessage" :disabled="loading">{{ env != 'admin' ? __('ai_chatbox', 'send') : 'Send' }}</div>
                    </div>
                </div>
            </div>
        </transition>
        <div id="ai-chatbox-btn" @click="toggleOpen" v-show="showed">
            {{ env != 'admin' ? __('ai_chatbox', 'chat_with_our_ai') : 'Chat with AI assistant' }}
            <i :class="{ 'fa-solid fa-message': env == 'front', 'las la-magic': env == 'admin' }" class="ms-2"></i>
        </div>
    </div>
</template>

<script>
import { nextTick } from 'vue';
export default {
    props: [
        'env' // front or admin
    ],
    data() {
        return {
            t: t,
            config: config,
            session: session,
            settings: settings,
            showed: this.env == 'admin' ? true : session['ai_chatbox_' + this.env + '_showed'],
            opened: session['ai_chatbox_' + this.env + '_opened'],
            message: '',
            chatMessages: session['ai_chatbox_messages' + (this.env == 'admin' ? '_admin' : '')] || [],
            loading: false,
            converter: new markdownit({
                breaks: true,
            }),
            greeting_message: ''
        }
    },
    mounted() {
        if(this.env == 'admin') {
            this.greeting_message = this.converter.render(this.config.ai_chatbox.admin_markdown_greeting_message)
        }
        this.init()
        this.$root.$on('show-chatbox', () => {
            this.showChatbox();
        });
    },
    methods: {
        init() {
            this.chatMessages.forEach((chatMessage) => {
                chatMessage.content = this.converter.render(chatMessage.content.replace(/\\n/g, '\n'));
            });
            nextTick(() => {
                this.scrollLastMessageIntoView()
            })
        },
        async sendMessage() {
            if (this.message.trim() === '') {
                return;
            }

            this.loading = true;

            this.chatMessages = [
                ...this.chatMessages,
                {
                    role: 'user',
                    content: this.message
                },
                {
                    role: 'assistant',
                    content: this.env == 'admin' ? 'Loading...' : this.__('ai_chatbox', 'loading')
                }
            ];

            let message = this.message;
            this.message = '';

            // nextTick is used to wait for the DOM to update
            nextTick(() => {
                this.scrollLastMessageIntoView()
            })

            axios.get('/ai-chatbox/send', { message: message })
                .then(response => {
                    console.log(response.data);
                })

            let markdownBuffer = '';
            // use eventSource in POST request
            let eventSource = new EventSource(this.url((this.env == 'admin' ? 'admin/ajax/' : '') + 'ai-chatbox/send') + '?message=' + message);
            let lastMessage = this.chatMessages[this.chatMessages.length - 1];
            eventSource.addEventListener('message', (event) => {
                // Remove the 'Loading...' text from the last message
                lastMessage.content = lastMessage.content.replace(this.env == 'admin' ? 'Loading...' : this.__('ai_chatbox', 'loading'), '');

                // // Append incoming data to the markdown buffer
                markdownBuffer += event.data.replace(/\\n/g, '\n')

                // lastMessage.content = converter.makeHtml(markdownBuffer);
                lastMessage.content = this.converter.render(markdownBuffer);

                this.scrollLastMessageIntoView()
            });
            // stop event
            eventSource.addEventListener('stop', () => {
                lastMessage.content = this.converter.render(markdownBuffer);
                eventSource.close();
                this.loading = false;
            });
        },
        scrollLastMessageIntoView() {
            let element = document.getElementById('ai-chatbox-messages')
            element.scrollTop = element.scrollHeight
        },
        showChatbox() {
            this.opened = true
            this.showed = true
            axios.post('/ai-chatbox/show', {
                env: this.env
            }).then(response => {
                document.querySelector('#ai-chatbox input').focus()
            })
        },
        toggleOpen() {
            this.opened = !this.opened
            axios.post('/ai-chatbox/' + (this.opened ? 'open' : 'close'), {
                env: this.env
            }).then(response => {
                if (this.opened) {
                    this.scrollLastMessageIntoView()
                    document.querySelector('#ai-chatbox input').focus()
                }
            })
        },
    }

}
</script>
